
// Definición de defaults

export const defaultSexo: SexoProps = {
    idSexo:          0,
    descripcion:     '',
    abreviacion:     '',
    activo:          false,
}

// Creación de interfaces

export interface SexoProps {
    idSexo:              number;
    descripcion:         string;
    abreviacion:         string;
    activo:              boolean;
}